import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { Sections } from '../../Components/Containers/Section';
import { PageLoading } from '../../Components/Loading';
import BarPieTableChart from './Components/BarPieTableChart';
import { useStats } from '../../Data/Rounds';
import { durationToSeconds } from '../../Services/helpers';

const Rounds = () => {
    const {stats} = useStats(true);

    return <>
        <TopBar left="/reports" title="Rounds" />
        <Page>
            {stats ? <Inner {...{stats}} /> : <PageLoading />}
        </Page>
    </>
}

const Inner = ({stats, services}) => {
    return <Sections>
        <BarPieTableChart title="Jobs"
            dataLabel="Jobs"
            groupingLabel="Round"
            subtitle="Count of jobs by round"
            labelValueData={stats.jobCount.map(s => ({label: s.name, value: s.jobCount}))}
        />
        <BarPieTableChart title="Job Cost"
            dataLabel="Cost"
            groupingLabel="Round"
            subtitle="Total cost of job by round"
            labelValueData={stats.jobCost.map(s => ({label: s.name, value: s.jobCost}))}
            dataType="currency"
        />
        <BarPieTableChart title="Annual Value"
            dataLabel="Cost"
            groupingLabel="Round"
            subtitle="Annual value of jobs by round"
            labelValueData={stats.annualValue.map(s => ({label: s.name, value: s.annualValue}))}
            dataType="currency"
        />
        <BarPieTableChart title="Job Duration"
            dataLabel="Time"
            groupingLabel="Round"
            subtitle="Total duration of jobs by round"
            labelValueData={stats.jobDuration.map(s => ({label: s.name, value: durationToSeconds(s.jobDuration)}))}
            dataType="time"
        />
        <BarPieTableChart title="Travel Duration"
            dataLabel="Time"
            groupingLabel="Round"
            subtitle="Total duration of travel between job by round"
            labelValueData={stats.travelDuration.map(s => ({label: s.name, value: durationToSeconds(s.travelDuration)}))}
            dataType="time"
        />
    </Sections>
}


export default Rounds;
